/**
 * Sovrynn wordmark + trailing lines. Brand Identity: always italic, weight 800, two amber gradient lines to the right.
 * Sizes: xl | lg | md | sm | xs | xxs. Variants: on-amber | on-light (for bg switching).
 */
import React from 'react';
import './brand.css';

const SIZES = ['xxs', 'xs', 'sm', 'md', 'lg', 'xl'];

export default function SovrynnLogo({ size = 'sm', variant, className = '' }) {
  const sizeClass = SIZES.includes(size) ? size : 'sm';
  const variantClass = variant === 'on-amber' ? 'on-amber' : variant === 'on-light' ? 'on-light' : '';
  const classes = ['sv-logo', sizeClass, variantClass, className].filter(Boolean).join(' ');
  return (
    <div className={classes} aria-label="Sovrynn">
      <span className="sv-logo__wm">Sovrynn</span>
      <div className="sv-logo__trails">
        <div className="sv-logo__t1" />
        <div className="sv-logo__t2" />
      </div>
    </div>
  );
}
